import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { AiOutlineClose } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import {
  useAddBoardMutation,
  useGetBoardTypesQuery,
  useUpdateBoardMutation,
} from '../../../../services/api/apiProvider';
import { ResponseBoardType } from '../../../../services/api/models/response/responseBoard';
import { AppState } from '../../../../store/store';
import { actions } from '../../liveSlice';
import BarLoader from 'react-spinners/BarLoader';

import './LiveListBoard.scss';

export const ListBoard = (): ReactElement => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const liveData = useSelector((state: AppState) => state.live.liveData);
  const { data: boardTypesData, isLoading } = useGetBoardTypesQuery();
  const [addBoard] = useAddBoardMutation();
  const [updateBoard] = useUpdateBoardMutation();

  const handleAddBoard = async (type: ResponseBoardType) => {
    if (!liveData || !type) {
      return;
    }

    // already has board, update it
    if (liveData.board) {
      if (liveData.board.type.id === type.id) {
        return;
      }

      dispatch(
        actions.updateLiveBoard({
          ...liveData.board,
          type,
        }),
      );

      updateBoard({
        id: liveData.board.id,
        boardTypeId: type.id,
      });
    }
    // create new board
    else {
      const board = await addBoard({
        liveId: liveData.id,
        boardTypeId: type.id,
      }).unwrap();
      if (board) {
        dispatch(actions.updateLiveBoard(board));
        dispatch(actions.showListBoard(false));
      }
    }
  };

  return (
    <div className="list-board">
      <div
        className="list-board__close-btn"
        onClick={() => {
          dispatch(actions.showListBoard(false));
        }}
      >
        <AiOutlineClose />
      </div>

      <div className="list-board__header">{t('Boards')}</div>

      <div className="list-board__body">
        {/* Loading progress */}
        {isLoading && (
          <BarLoader
            color={'#0275d8'}
            width="100%"
            cssOverride={{}}
          ></BarLoader>
        )}

        {/* Board list */}
        {boardTypesData &&
          boardTypesData.map((type) => (
            <div
              key={type.id}
              className="board-item"
              onClick={() => {
                handleAddBoard(type);
              }}
            >
              <img src={type.image.uri} />
            </div>
          ))}
      </div>
    </div>
  );
};
